module.exports = __webpack_public_path__ + "static/media/3.2e3b38e4.jpg";